// Author liang gang qiang
// Date 2023-09-28 09:53:17

import * as model from "@/model/sithMesII/plan/SithMomMainProjectPlanScheduledRecordModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMomMainProjectPlanScheduledRecord(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMESII_PLAN_URL,
    })
    .buildStore()
